import styled from "@emotion/styled";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { Heading, Text } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import { ChangeDirection } from "constants/change-direction";
import { anyToBoolean } from "helpers/boolean";

import { ChangeLabel } from "./ChangeLabel";

const StyledAnchorContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
  cursor: pointer;
  text-decoration: none !important;
`;

const StyledValue = styled(Heading)`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div`
  width: 20px;
  margin: -3px 4px 0 0;
`;

interface ILinkWrapperProps {
  href?: string;
  onClick?(): void;
}

interface IProps extends ILinkWrapperProps, RouteComponentProps {
  icon?: IconsEnum;
  label?: string;
  value?: string | number;
  emptyState?: string | React.ReactElement;
  change?: number;
  positive?: boolean;
  color: string;
}

const DataRow: React.FC<IProps> = props => (
  <StyledAnchorContainer
    onClick={() => {
      if (props.href) {
        props.history.push(props.href);
      }
      return props.onClick && props.onClick();
    }}
  >
    <Text>{props.label}</Text>
    <StyledValue size="lg">
      {props.icon && (
        <IconWrapper>
          <Icon name={props.icon} width="20px" fill={props.color} />
        </IconWrapper>
      )}
      {anyToBoolean(props.value) || props.value === 0 ? props.value : props.emptyState}
    </StyledValue>
    {/* @ts-expect-error TS(2345): Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message */}
    {props.value && !isNaN(props.change) && props.change !== 0 ? (
      <ChangeLabel
        // @ts-expect-error TS(2345): Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
        value={`${Math.abs(props.change)} p. p.`}
        positive={props.positive}
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        direction={props.change > 0 ? ChangeDirection.Up : ChangeDirection.Down}
      />
    ) : null}
  </StyledAnchorContainer>
);

export const SummaryDataRow = withRouter(DataRow);
